import { useCallback } from 'react';
import { StatusBar } from 'react-native';
import { NavigationContainer } from './NavigationContainer';
import EpaAuthProvider from '@/contexts/EpaAuthContext';

import { isPatientApp } from '@/config/constants';
import { usePrivacy } from '@/hooks/usePrivacy';

import { DialogProvider } from '@/components/ui/shared/Dialog';

import { AnonymousStack } from './AnonymousStack';
import { PatientStack } from './PatientStack';
import { TherapistStack } from './TherapistStack';
import { useStoreState } from '@/stores/store';
import { PostHogEventsProvider } from '@/contexts/EventsProvider/PostHogProvider';
import { logError } from '@/utils/logHandling';
import { Filler } from '@/screens/Filler';

function ActiveStack({ isAuthenticated }: { isAuthenticated: boolean }) {
  const isPrivate = usePrivacy(isAuthenticated);

  return (
    <>
      {isAuthenticated && isPatientApp ? <PatientStack /> : null}
      {isAuthenticated && !isPatientApp ? <TherapistStack /> : null}
      {!isAuthenticated && <AnonymousStack />}
      {isPrivate ? <Filler /> : null}
    </>
  );
}

export function AppNavigation() {
  const { isAuthenticated } = useStoreState((store) => ({
    isAuthenticated: store.isAuthenticated,
  }));

  const onPostHogError = useCallback(
    (error: Error) => logError('PostHog initialization error:', error),
    [],
  );

  return (
    <NavigationContainer>
      <PostHogEventsProvider onError={onPostHogError}>
        <StatusBar hidden={true} translucent={true} />
        <DialogProvider>
          <EpaAuthProvider>
            <ActiveStack isAuthenticated={isAuthenticated} />
          </EpaAuthProvider>
        </DialogProvider>
      </PostHogEventsProvider>
    </NavigationContainer>
  );
}
